import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "confirmation-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.showDialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog = $event)),
    style: { width: '50vw' },
    modal: true,
    onHide: _ctx.onHide
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("experiment.list-experiment.dialog.delete.title")), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _ctx.$t('button.no'),
        icon: "pi pi-times",
        class: "p-button-text",
        onClick: _ctx.onClickNo
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        label: _ctx.$t('button.yes'),
        icon: "pi pi-check",
        class: "p-button-text p-button-danger",
        onClick: _ctx.onClickYes
      }, null, 8, ["label", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.name)
          ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("experiment.list-experiment.dialog.delete.confirm_message", {
            name: _ctx.name,
          })), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}